export default "__VITE_ASSET__DT08a0Bg__"